import { render, staticRenderFns } from "./UpdateProject.vue?vue&type=template&id=502ebb36&scoped=true"
import script from "./UpdateProject.vue?vue&type=script&lang=js"
export * from "./UpdateProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502ebb36",
  null
  
)

export default component.exports